export const COLOR_PRIMARY = 'navy';
export const COLOR_RPG_TEXT = '#fff';
export const COLOR_RPG_FRAME = '#fff';
export const COLOR_RPG_BACKGROUND = '#000';
export const COLOR_LABEL_TEXT = '#000';
export const COLOR_BACKGROUND = '#eee';
export const COLOR_PLACEHOLDER = '#555';
